import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/pro-solid-svg-icons/faLock';
import { faQuestionCircle } from '@fortawesome/pro-solid-svg-icons/faQuestionCircle';
import { faXmark } from '@fortawesome/pro-solid-svg-icons/faXmark';
import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck';
import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import Global from '../../../store/global-selectors';
import { InventoryService } from '../../../services/inventory-service';

import style from '../style.module.less';
import { emptyObject } from 'ui-components/default-props/empty';

const determineIconToRender = (isAllocatable, isAllocated, isUnknown) => {
  if (isUnknown) {
    return (
      <div className={style['black-background']}>
        <FontAwesomeIcon icon={faQuestionCircle} />
      </div>
    );
  }

  if (!isAllocatable && !isAllocated) {
    return (
      <div className={style['red-background']}>
        <FontAwesomeIcon icon={faXmark} />
      </div>
    );
  }

  if (isAllocatable && !isAllocated) {
    return (
      <div className={style['green-background']}>
        <FontAwesomeIcon icon={faCheck} />
      </div>
    );
  }

  if (isAllocated) {
    return (
      <div className={style['blue-background']}>
        <FontAwesomeIcon icon={faLock} />
      </div>
    );
  }
};

const decideIfShouldBeHidden = (state, isInOrdersDrawer, fulfillmentPlanId) => {
  const numberOfSelectedOrders = Global.selectSelectedOrdersCount(state);
  if (numberOfSelectedOrders > 1) {
    return true;
  }

  if (!InventoryService.shouldItemInventoryInformationShow(state, fulfillmentPlanId, isInOrdersDrawer)) {
    return true;
  }

  const fulfillmentPlanShipFromId = Global.selectEntitiesFulfillmentPlanShipFromId(state, {
    fulfillmentPlanId,
  });
  if (!InventoryService.doesShipFromHaveNativeInventoryTrackingEnabled(fulfillmentPlanShipFromId, state)) {
    return true;
  }

  return false;
};

export const InventoryItemIcon = ({ orderItem = emptyObject, isInOrdersDrawer = false, fulfillmentPlanId = '' }) => {
  const shouldBeHidden = useSelector((state) => decideIfShouldBeHidden(state, isInOrdersDrawer, fulfillmentPlanId));

  const isUnknown = useSelector((state) => InventoryService.isItemInventoryUnknown(state, isInOrdersDrawer, fulfillmentPlanId, orderItem));
  const isAllocatable = useSelector((state) => InventoryService.canItemBeAllocated(state, isInOrdersDrawer, fulfillmentPlanId, orderItem));
  const isAllocated = useSelector((state) => InventoryService.isItemAllocated(state, isInOrdersDrawer, fulfillmentPlanId, orderItem));

  if (shouldBeHidden) {
    return null;
  }
  return <>{determineIconToRender(isAllocatable, isAllocated, isUnknown)}</>;
};

InventoryItemIcon.propTypes = {
  orderItem: PropTypes.object,
  isInOrdersDrawer: PropTypes.bool,
  fulfillmentPlanId: PropTypes.string,
};
